import { Component, Input, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { properties } from "src/environments/properties";
import { SubscriptionService } from "../../../shared/services/subscription.service";

@Component({
  selector: "app-change-plan",
  templateUrl: "./change-plan.component.html",
  styleUrls: ["./change-plan.component.scss"],
})
export class ChangePlanComponent implements OnInit {
  @Input() userSubscriptionDetails: any;
  @Input() userInfo: any;
  @Input() currentEnvironment;
  @Input() fetchedPlans;
  nonSelectedSubscriptionType: any;
  pricingDetail: any;
  currentPlanExpiryDate: string;
  governmentAssisted = "";
  properties = properties;

  constructor(
    public subscriptionService: SubscriptionService,
    private titleService: Title
  ) {
    this.setTitle("Freshpass - Change Plan");
  }

  ngOnInit(): void {
    if (this.fetchedPlans) {
      const subscriptions = this.fetchedPlans?.Data?.subscriptions || [];
      const value = subscriptions?.some(
        (plan) => plan.promoCategory === properties.planCard.SNAP
      );
      this.governmentAssisted = value ? properties.changePlan.govtAssisted : "";
      if (this.userSubscriptionDetails) {
        this.analyticsUserSubscriptionInfo(this.userSubscriptionDetails);
        if (
          this.userSubscriptionDetails.subscriptionType ===
          properties.planCard.MonthlyPlan
        ) {
          this.nonSelectedSubscriptionType = properties.confirmation.ANNUAL;
        } else {
          this.nonSelectedSubscriptionType = properties.confirmation.MONTHLY;
        }

        if (this.userSubscriptionDetails.pricingDetail === " / month") {
          this.pricingDetail = properties.changePlan.month;
        } else {
          this.pricingDetail = properties.changePlan.year;
        }
        if (this.userSubscriptionDetails.curentPlanExpiryDate) {
          this.currentPlanExpiryDate = this.subscriptionService.convertDate(
            this.userSubscriptionDetails.curentPlanExpiryDate
          );
        }
      }
    }
  }

  setTitle(newTitle: string): void {
    this.titleService.setTitle(newTitle);
  }

  analyticsUserSubscriptionInfo(userSubscriptionDetails) {
    if (
      userSubscriptionDetails.subscriptionStatus === properties.manage.TRIAL ||
      userSubscriptionDetails.subscriptionStatus === properties.changePlan.trial
    ) {
      localStorage.setItem("analyticsTrialFPUpdate", "true");
    }
    if (userSubscriptionDetails.isExtendedTrialDuration) {
      localStorage.setItem(
        "analyticsFPExtPlan",
        userSubscriptionDetails.isExtendedTrialDuration
      );
    }
    if (userSubscriptionDetails.isDiscountedPrice) {
      localStorage.setItem(
        "analyticsFPDiscountPlan",
        userSubscriptionDetails.isDiscountedPrice
      );
    }
  }

  getCurrentPlanExpiryDate(currentPlanExpiryDate): string {
    const date = new Date(currentPlanExpiryDate);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options).replace(",", "");
  }
}
